var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlumni(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 14.8118V13.4784C15.3331 12.8876 15.1364 12.3136 14.7744 11.8466C14.4124 11.3797 13.9056 11.0461 13.3335 10.8984",
    stroke: "inherit",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 14.8125V13.4792C11.3332 12.7719 11.0522 12.0936 10.5521 11.5935C10.052 11.0935 9.37375 10.8125 8.6665 10.8125H3.33317C2.62593 10.8125 1.94765 11.0935 1.44755 11.5935C0.947456 12.0936 0.666504 12.7719 0.666504 13.4792V14.8125",
    stroke: "inherit",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 2.89844C11.2401 3.0453 11.7485 3.3789 12.1116 3.84664C12.4747 4.31438 12.6717 4.88966 12.6717 5.48177C12.6717 6.07388 12.4747 6.64916 12.1116 7.1169C11.7485 7.58464 11.2401 7.91824 10.6665 8.0651",
    stroke: "inherit",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 8.14583C7.47292 8.14583 8.66683 6.95193 8.66683 5.47917C8.66683 4.00641 7.47292 2.8125 6.00016 2.8125C4.5274 2.8125 3.3335 4.00641 3.3335 5.47917C3.3335 6.95193 4.5274 8.14583 6.00016 8.14583Z",
    stroke: "inherit",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumni);
export default __webpack_public_path__ + "static/media/alumni.3e83eb79244fd98304dd626c452d19cb.svg";
export { ForwardRef as ReactComponent };